<template>
  <div class="order">
    <div class="order-content">
      <div class="order-title">
        <h2>订单</h2>
      </div>
      <div class="order-btn">
        <div class="recharge-section">
          <label class="recharge-label">选择充值金额</label>
          <div class="quick-amounts">
            <div 
              class="amount-item" 
              :class="{ active: money === item }"
              v-for="item in [300, 50, 100, 200, 500, 1000]"
              :key="item"
              @click="money = item"
            >
              ¥{{ item }}
            </div>
          </div>
          <el-button type="primary" @click="topup" :disabled="!money">立即充值</el-button>
        </div>
      </div>
      <div>
        <el-select
          v-model="chooseInfor.status"
          placeholder="请选择"
          @change="choosestatus"
        >
          <el-option
            v-for="item in options"
            :key="item.status"
            :label="item.label"
            :value="item.status"
          >
          </el-option>
        </el-select>
      </div>
      <div>
        <el-table :data="orderData" style="width: 100%">
          <el-table-column label="用户" width="200">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.user_id }}</span>
            </template>
          </el-table-column>
          <el-table-column label="金额" width="200">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.money }}</span>
            </template>
          </el-table-column>
          <el-table-column label="余额" width="200">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{
                scope.row.change_money_befor
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                @click="pay(scope.$index, scope.row)"
                v-if="scope.row.status == 0"
                >支付</el-button
              >
              <div v-if="payInfo" class="pay-info">
                <h3>支付信息：</h3>
                <p>{{ payInfo }}</p>
              </div>

              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                v-if="scope.row.status == 0"
                >删除订单</el-button
              >
              <el-button
                size="mini"
                type="warning"
                @click="handleEdit(scope.$index, scope.row)"
                v-if="scope.row.status == 0"
                >取消充值</el-button
              >
              <el-button size="mini" type="danger" v-else>
                {{
                  scope.row.status == 1
                    ? "成功"
                    : scope.row.status == 2
                    ? "失败"
                    : "已取消"
                }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[5, 20, 50, 100]"
          :page-size="pagination.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>
  </div>

  
</template>


<script>
export default {
  data() {
    return {
      money: "",
      orderData: [],
      options: [
        {
          status: 0,
          label: "待支付",
        },
        {
          status: 1,
          label: "成功",
        },
        {
          status: 2,
          label: "失败",
        },
        {
          status: 3,
          label: "已取消",
        },
        {
          status: 1000,
          label: "全部 ",
        },
      ],

      chooseInfor: {
        type: "1",
        status: 1000,
      },
      payInfo: "", // 添加这一行用于存储支付信息
      // 分页数据
      pagination: {
        page: 1,
        limit: 5,
        total: 0
      }
    };
  },
  methods: {
    back() {
      //返回首页
      this.$router.push({ path: "/market" });
    },
    async handleEdit(index, row) {
      //取消充值
      const res = await this.$api.order.canceOrder({ orderId: row.id });
      console.log(res);
      if (res.code == 200) {
        this.$message.success("取消成功");
      }
      this.getOrder();
    },
    async handleDelete(index, row) {
      //订单删除
      const res = await this.$api.order.delOrder({ orderId: row.id });
      console.log(res);
      this.getOrder();
    },
    cancel(index, row) {
      //充值
      console.log(index, row);
      this.getOrder();
    },
    async getOrder() {
      //订单列表
      

      const params = {
        ...this.chooseInfor,
        page: this.pagination.page,
        limit: this.pagination.limit
      };
      
      const res = await this.$api.order.getOrderList(params);
      console.log("消耗记录", res);
      if (res.code == 200) {
        this.orderData = res.data.list || res.data; // 根据实际返回结构调整
        this.pagination.total = res.data.total || 0; // 根据实际返回结构调整
      }
    },
    async topup() {
      //充值订单
      if (!this.money) {
        this.$message.warning("请输入金额");
        return;
      } else {
        const res = await this.$api.order.gotopUpt({ money: this.money });
        console.log(999);
        
        // 先提前打开空白窗口（避免被拦截）
        const payWindow = window.open('', `pay_${Date.now()}`, 'width=800,height=600');
        if (!payWindow) {
          this.$message.warning("浏览器拦截了支付窗口，请允许弹窗后重试");
          return;
        }
        try {
          
          // 写入内容到新窗口
          payWindow.document.write(res);
          payWindow.document.close();
          this.getOrder();
        } catch (e) {
          // 接口失败时关闭空白窗口
          payWindow.close();
          this.$message.error("充值请求失败：" + e.message);
        }
            await this.getOrder();
      }
    },
    choosestatus(value) {
      //选择订单列表
      console.log("选择的status:", value);
      this.getOrder(this.chooseInfor);
    },
    async pay(index, row) {
      
        try {
      //支付
      const res = await this.$api.order.orderPay({ orderId: row.id });
        // 先提前打开空白窗口（避免被拦截）
        const payWindow = window.open('', `pay_${Date.now()}`, 'width=800,height=600');
        if (!payWindow) {
          this.$message.warning("浏览器拦截了支付窗口，请允许弹窗后重试");
          return;
        }
          // 写入内容到新窗口
          payWindow.document.write(res);
          payWindow.document.close();
          this.getOrder();
        } catch (e) {
          // 接口失败时关闭空白窗口
          payWindow.close();
          this.$message.error("充值请求失败：" + e.message);
        }
        this.getOrder();
      
    },
    handleSizeChange(val) {
      console.log("分页大小改变", val);
      this.pagination.limit = val;
      this.pagination.page = 1; 
      this.getOrder();
    },
    handleCurrentChange(val) {
      
      this.pagination.page = val;
      this.getOrder();
    }
  },
  created() {
    this.getOrder();
  },
};
</script>

<style lang="scss">
.order {
  background-color: #f1f4fb;
  min-height: 100vh;
  padding: 20px;
  
  .order-content {
    background-color: #ffffff;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  }
  
  .order-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    
    h2 {
      font-size: 20px;
      font-weight: 600;
      color: #1a1a2e;
      margin: 0;
    }
  }
  
  .order-btn {
    margin-bottom: 20px;
    
    .recharge-section {
      background: linear-gradient(135deg, #f8f9fc 0%, #ffffff 100%);
      border-radius: 16px;
      padding: 24px;
      border: 1px solid rgba(94, 96, 206, 0.1);
    }
    
    .recharge-label {
      display: block;
      font-size: 14px;
      color: #4a4a68;
      margin-bottom: 16px;
      font-weight: 500;
    }
    
    .quick-amounts {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 12px;
      margin-bottom: 20px;
      
      .amount-item {
        padding: 14px 12px;
        text-align: center;
        border: 2px solid #e8eaf2;
        border-radius: 12px;
        font-size: 16px;
        font-weight: 600;
        color: #4a4a68;
        cursor: pointer;
        transition: all 0.3s ease;
        background: #ffffff;
        
        &:hover {
          border-color: #5e60ce;
          color: #5e60ce;
          background: rgba(94, 96, 206, 0.03);
        }
        
        &.active {
          border-color: #5e60ce;
          background: linear-gradient(135deg, rgba(94, 96, 206, 0.1), rgba(124, 127, 246, 0.05));
          color: #5e60ce;
          box-shadow: 0 4px 12px rgba(94, 96, 206, 0.15);
        }
      }
    }
    
    .el-button {
      padding: 12px 32px;
      border-radius: 10px;
      font-weight: 500;
      background: linear-gradient(135deg, #5e60ce, #7c7ff6);
      border: none;
      box-shadow: 0 4px 12px rgba(94, 96, 206, 0.3);
      
      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(94, 96, 206, 0.4);
      }
      
      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        background: linear-gradient(135deg, #8a8aa3, #a0a0b8);
      }
    }
  }
  
  .pay-info {
    margin-top: 20px;
    padding: 15px;
    background-color: #e8f4fd;
    border-radius: 4px;
    
    h3 {
      margin-top: 0;
      color: #333;
    }
    
    p {
      margin: 0;
    }
  }
}

@media (max-width: 768px) {
  .order .order-btn .quick-amounts {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>